import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useForm } from "react-hook-form"
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import { ApiUrl, Headers } from '../services/ApiUrl'
import axios from 'axios'
import { Navigate, useNavigate } from 'react-router-dom'
import { useUserAdminStore } from '../stores/userAdmin';

const LoginUsuariosAdmin = () => {
    const [showInput, setShowInput] = useState(false);
    const { updateUserAdmin, setError, userAdmin } = useUserAdminStore();
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm()

    const onSubmit = async (data) => {
        try {
            let url = ApiUrl + 'users?login=true&suffix=user';
            const response = await axios.post(url, data, { headers: Headers });

            if (response.data.results[0].tipo_user !== "admin") {
                setError("No es un usuario admin");
                return;
            }

            // Actualizar el store con los datos del usuario
            updateUserAdmin(response.data.results[0]);
            
            // Navegamos después de actualizar el store
            navigate('/paneladmin');

        } catch (error) {
            setError(error.response?.data?.results || 'Error al iniciar sesión');
        }
    };

    // Si ya está logueado, redirigimos directamente
    if (userAdmin.login) {
        return <Navigate to="/paneladmin" replace />;
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Container style={{ marginTop: '50px' }}>
                <Row>
                    <Col>
                        <h1>Panel de administración</h1>
                    </Col>
                </Row>

                <Row style={{ marginTop: '30px' }}>
                    <Col>
                        <Card>
                            <Card.Header>
                                <i className="bi bi-lock"></i> Inicio de sesión
                            </Card.Header>
                            <Card.Body>
                                <ListGroup className="list-group-flush">
                                    <ListGroup.Item>
                                        <Form.Group className="mb-3">
                                            <Form.Label size="lg">Correo electrónico</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Correo electrónico..."
                                                {...register("email_user", {
                                                    required: "El correo electrónico es obligatorio",
                                                    pattern: {
                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                        message: "El formato del correo electrónico es incorrecto"
                                                    }
                                                })}
                                                isInvalid={errors.email_user}
                                                autoComplete='nope'
                                            />

                                            {errors.email_user && (
                                                <Alert style={{ marginTop: '10px' }} variant="danger">
                                                    {errors.email_user?.message}
                                                </Alert>
                                            )}
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label size="lg">Contraseña</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Button 
                                                    variant="outline-secondary" 
                                                    onClick={() => setShowInput(!showInput)}
                                                >
                                                    <i className={`bi bi-eye${showInput ? '-fill' : '-slash-fill'}`}></i>
                                                </Button>
                                                <Form.Control
                                                    type={showInput ? 'text' : 'password'}
                                                    placeholder="Contraseña..."
                                                    {...register("password_user", {
                                                        required: "La contraseña es obligatoria",
                                                        minLength: { 
                                                            value: 8, 
                                                            message: "El mínimo de caracteres para la contraseña es 8" 
                                                        },
                                                    })}
                                                    isInvalid={errors.password_user}
                                                    autoComplete='nope'
                                                    maxLength='20'
                                                />
                                            </InputGroup>

                                            {errors.password_user && (
                                                <Alert style={{ marginTop: '10px' }} variant="danger">
                                                    {errors.password_user?.message}
                                                </Alert>
                                            )}
                                        </Form.Group>

                                        <Button type="submit" style={{ width: '200px' }}>
                                            Iniciar sesión
                                        </Button>
                                    </ListGroup.Item>

                                    <ListGroup.Item>
                                        {userAdmin.error && (
                                            <Alert variant="danger">
                                                {userAdmin.errorMsg}
                                            </Alert>
                                        )}
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Form>
    );
};

export default LoginUsuariosAdmin;